/**
 * Toggle color constants
 */
export const TOGGLE_COLORS = {
  BRAND: 'brand',
  NEUTRAL: 'neutral',
} as const
